import axiosInstance from "./api";

export type BillingInterval = 'MONTHLY' | 'ANNUAL';

export interface SubscriptionInfo {
    hasActiveSubscription: boolean;
    tier: string;
    billingInterval?: string;
    status?: string;
    billingPeriodStart?: string;
    billingPeriodEnd?: string;
    cancelledAt?: string;
}

export const createCheckoutSession = async (
    tier: 'PRO' | 'ENTERPRISE',
    interval: BillingInterval = 'MONTHLY'
): Promise<string> => {
    try {
        const response = await axiosInstance.post<{ checkoutUrl: string }>(
            `/payments/checkout?tier=${tier}&interval=${interval}`
        );
        return response.data.checkoutUrl;
    } catch (error) {
        console.error("Error creating checkout session", error);
        throw error;
    }
};

export const cancelSubscription = async (): Promise<{ message: string }> => {
    const response = await axiosInstance.post<{ message: string }>('/payments/cancel');
    return response.data;
};

export const changePlan = async (
    tier: 'PRO' | 'ENTERPRISE' | 'BASIC',
    interval: BillingInterval = 'MONTHLY'
): Promise<{ checkoutUrl?: string; message?: string }> => {
    const response = await axiosInstance.post<{ checkoutUrl?: string; message?: string }>(
        `/payments/change-plan?tier=${tier}&interval=${interval}`
    );
    return response.data;
};

export const getSubscription = async (): Promise<SubscriptionInfo> => {
    const response = await axiosInstance.get<SubscriptionInfo>('/payments/subscription');
    return response.data;
};
